/* eslint-disable arrow-body-style */
import React, { useMemo } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { EuiTitle } from "@elastic/eui";
import SectionsCard from "../shared/tripReconiliation/SectionsCard";
import { TripPiceBox } from "./style";

const TotalPrice = ({ prices }) => {
    const intl = useIntl();
    const tripPrices = useMemo(
        () => [
            {
                name: <FormattedMessage id="trip.reconciliation.totalprice.total" />,
                price: prices?.totalsSummary || 0,
                id: 1,
            },
            {
                name: <FormattedMessage id="trip.reconciliation.totalprice.driver" />,
                price: prices?.driverWage || 0,
                id: 2,
            },
            {
                name: <FormattedMessage id="trip.reconciliation.totalprice.truck" />,
                price: prices?.truckWage || 0,
                id: 3,
            },
            {
                name: <FormattedMessage id="trip.reconciliation.totalprice.supplier" />,
                price: prices?.supplierWage || 0,
                id: 4,
            },
        ],
        [intl.locale, prices]
    );

    return (
        <SectionsCard title={<FormattedMessage id="trip.reconciliation.totalprice" />}>
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-around",
                    gap: "16px",
                }}
            >
                {tripPrices.map((el) => (
                    <TripPiceBox key={el.id}>
                        <h4>{el.name}</h4>
                        <EuiTitle size="s">
                            <p>{el.price}</p>
                        </EuiTitle>
                    </TripPiceBox>
                ))}
            </div>
        </SectionsCard>
    );
};

export default TotalPrice;
